import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router";
import { useDispatch, useStore } from "react-redux";
import {
  IonAlert,
  IonBadge,
  IonButton,
  IonCard,
  IonCheckbox,
  IonContent,
  IonDatetime,
  IonLabel,
  IonLoading,
  IonPage,
  IonSelect,
  IonSelectOption,
  IonProgressBar,
} from "@ionic/react";
import { decode } from "base64-arraybuffer";
import { useForm } from "react-hook-form";

import {
  adjustBorderHeight,
  adjustBackgroundHeight,
  getQrCodeInfo,
  noInternetResponse,
  showToastMessage
} from "../../common/common";
import { getModelProfileData } from "../../data-services/edit-profile";
import { Network } from "@capacitor/network";
import axios from "axios";



const QR19Success: React.FC = () => {
  const history = useHistory();
  const photoContainerRef = useRef<HTMLDivElement>(null);

  const [qrDetails, setQrDetails] = useState<any>();
  const populateQrCodeInfo = () => {
    let qrDetails = getQrCodeInfo();
    setQrDetails(qrDetails);
  }

  useEffect(() => {
    populateQrCodeInfo();
    adjustBorderHeight(850);
    adjustBackgroundHeight(850);
  }, []);

  const trackCTAClick = async () => {
    const options: any = {
      method: "post",
      url: `${process.env.REACT_APP_HP_API_URL}/users/registerConsumerCTA`,
      data: {
        uuid: localStorage.getItem('uuid'),
        ctaType: "cta1",
        ctaLabel: 'LYT CTA button pressed'
      },
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    await axios(options);
    window.location.href = 'https://discover.gotoaisle.com/offers/cmqiofmuo0001e2g51ztb2tq9'
  }

  return (
    <IonPage style={{background: '#f5f0dc', alignItems: 'center'}}>

      <IonContent className={`lay__container--${qrDetails?.eventQrId}`} style={{maxWidth: '420px', margin: '0 auto'}}>
        <div className="lay__background" style={{maxHeight: '850px', minHeight: 'auto'}}>
          <img src="https://pulseqr.b-cdn.net/qr19LYT/Background--no-logo.png" alt="Background" />
        </div>

        {typeof qrDetails != 'undefined' && 
          <div className={`lay__content--${qrDetails?.eventQrId}`}>

            <div className="lay__logo" style={{paddingTop: '30px'}}>
              <div className="">
                <img style={{paddingTop: '0', marginTop: '0'}} src="https://pulseqr.b-cdn.net/qr19LYT/logo.png" alt="LYT" />
              </div>
            </div>

            <div className="img__first img__first--full-width" style={{marginTop: '60px', marginBottom: '20px', padding: '0 20px'}}>
              <div className="talent-signup__section-title talent-signup__section-title--smaller2">
                <img src="https://pulseqr.b-cdn.net/qr19LYT/p5-img1.png" alt="Your Rewards Are Almost Ready" />
              </div>
            </div>

            <div className="img__inline" style={{marginTop: '10px', zIndex: 3, width: '280px', cursor: 'pointer'}} onClick={trackCTAClick}>
              <div>
                <img src="https://pulseqr.b-cdn.net/qr19LYT/CTA-Submit5.png" alt="Unlock My Rewards" />
              </div>
            </div>

          </div>}
          
      </IonContent>

    </IonPage>
  );
};

export default QR19Success;
